import { useAuthWithDefaults } from './AuthProvider';

export function Login() {
  const { signIn } = useAuthWithDefaults();

  signIn();
  return null;
}
